// extracted by mini-css-extract-plugin
export default {"socialIcon":"SocialIcon_socialIcon__JzBkM","large":"SocialIcon_large__DfSHC"};